require("sma.applicant/sass/read_more.sass")

class ReadMore {
	constructor(el, charLimit) {

		charLimit = charLimit || 720;
		var readMore = "Read more";
		var readLess = "Read less";
		var content = el.html();

		var className = "sma-js-read-more";
        var readMoreButton = null;

		if(content.length > charLimit) {
            readMoreButton = $("<a/>", {
            	role: "button",
            	text: readMore,
            	"class": "more-link"
            });
			$(el).after(readMoreButton);

            $(el).addClass(className)
        }
        else {
        	$(el).removeClass(className);
        }

        if(readMoreButton) {
            readMoreButton.click(function(){
            	$(el).toggleClass(className);

            	if($(el).hasClass(className)) {
            		readMoreButton.text(readMore)
            	} else {
            		readMoreButton.text(readLess)
            	}

    	        return false;
    	    });
        }
	}
}

module.exports = {
	ReadMore: ReadMore
}
